// Vendor libraries
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
// Directives
import { MetricByCategoryListDirective } from '../metric-by-category-list/metric-by-category-list.directive';
// Pipes
import { GetCategoryScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-scroll-id.pipe';
import { GetCategoryTopScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-top-scroll-id.pipe';
import { GetMetricScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-metric-scroll-id.pipe';
import * as i0 from "@angular/core";
import * as i1 from "CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-scroll-id.pipe";
import * as i2 from "CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-top-scroll-id.pipe";
import * as i3 from "CalculationsApp/ts/features/metric-selector-modal/pipes/get-metric-scroll-id.pipe";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../metric-info-modal/metric-info-modal.component";
import * as i7 from "../../pipes/get-category-scroll-id.pipe";
import * as i8 from "../../pipes/get-category-top-scroll-id.pipe";
import * as i9 from "../../pipes/get-metric-scroll-id.pipe";
import * as i10 from "../../pipes/is-item-selected.pipe";
import * as i11 from "../../pipes/is-submenu-item-selected.pipe";
const _c0 = a0 => ({ selected: a0 });
const _c1 = a0 => ({ open: a0 });
const _c2 = (a0, a1, a2, a3, a4) => [a0, a1, a2, a3, a4];
const _c3 = (a0, a1, a2, a3) => [a0, a1, a2, a3, undefined];
function SingleMetricByCategoryListComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵpipe(2, "getCategoryScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_6_Template_div_click_1_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectCategory(category_r2)); });
    i0.ɵɵelement(3, "span", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, category_r2.category_label === (ctx_r2.categorySelected == null ? null : ctx_r2.categorySelected.category_label)));
    i0.ɵɵadvance();
    i0.ɵɵattribute("category-scroll-id", i0.ɵɵpipeBind2(2, 3, ctx_r2.metricByCategoryListId, category_r2.category_label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.numSelectedPerCategoryMap[category_r2.category_label] ? category_r2.category_label + " (" + ctx_r2.numSelectedPerCategoryMap[category_r2.category_label] + ")" : category_r2.category_label);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "span", 12);
    i0.ɵɵpipe(2, "getCategoryTopScrollId");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    const section_r5 = ctx_r3.$implicit;
    const isFirstSection_r6 = ctx_r3.first;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", section_r5.section_label);
    i0.ɵɵattribute("category-top-scroll-id", isFirstSection_r6 ? i0.ɵɵpipeBind2(2, 2, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_6_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r9); const item_r8 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.openMetricInfoModal(item_r8.periods[0], $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵpipe(1, "getMetricScrollId");
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_13_Template_div_click_2_listener() { const period_r11 = i0.ɵɵrestoreView(_r10).$implicit; const item_r8 = i0.ɵɵnextContext(2).$implicit; const section_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectMetric(period_r11, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r8.menu_label)); });
    i0.ɵɵelement(3, "span", 12);
    i0.ɵɵtemplate(4, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_13_div_4_Template, 3, 1, "div", 22);
    i0.ɵɵpipe(5, "isItemSelected");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const period_r11 = ctx.$implicit;
    const item_r8 = i0.ɵɵnextContext(2).$implicit;
    const section_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("metric-scroll-id", i0.ɵɵpipeBindV(1, 3, i0.ɵɵpureFunction5(15, _c2, ctx_r2.metricByCategoryListId, period_r11.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r8.menu_label)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", period_r11.period_label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBindV(5, 9, i0.ɵɵpureFunction5(21, _c2, ctx_r2.selectedMetricsMap, period_r11.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r8.menu_label)));
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 11);
    i0.ɵɵpipe(2, "getCategoryTopScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r7); const item_r8 = i0.ɵɵnextContext().$implicit; const section_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggleSubmenu(section_r5.section_label, item_r8.menu_label)); });
    i0.ɵɵelement(3, "div", 19);
    i0.ɵɵelementStart(4, "span", 20);
    i0.ɵɵelement(5, "span", 12);
    i0.ɵɵtemplate(6, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_6_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_7_Template, 3, 1, "div", 22);
    i0.ɵɵpipe(8, "isSubmenuItemSelected");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 23)(10, "div", 24)(11, "div", 25);
    i0.ɵɵtext(12, " Select a Periodicity ");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_div_13_Template, 7, 27, "div", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const item_r8 = ctx_r11.$implicit;
    const isFirstSectionItem_r13 = ctx_r11.first;
    const section_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1, ctx_r2.submenuIsOpenMap == null ? null : ctx_r2.submenuIsOpenMap[section_r5.section_label] == null ? null : ctx_r2.submenuIsOpenMap[section_r5.section_label][item_r8.menu_label]));
    i0.ɵɵadvance();
    i0.ɵɵattribute("category-top-scroll-id", isFirstSectionItem_r13 && !section_r5.section_label ? i0.ɵɵpipeBind2(2, 6, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("textContent", item_r8.menu_label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showInfoPopover);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind4(8, 9, ctx_r2.selectedMetricsMap, ctx_r2.categorySelected.category_label, section_r5.section_label, item_r8.menu_label));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", item_r8.periods);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r15); const item_r8 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.openMetricInfoModal(item_r8, $event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵpipe(1, "getMetricScrollId");
    i0.ɵɵlistener("click", function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r14); const item_r8 = i0.ɵɵnextContext().$implicit; const section_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectMetric(item_r8, ctx_r2.categorySelected.category_label, section_r5.section_label)); });
    i0.ɵɵelementStart(2, "span", 32);
    i0.ɵɵpipe(3, "getCategoryTopScrollId");
    i0.ɵɵelement(4, "span", 12);
    i0.ɵɵtemplate(5, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_div_5_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_div_6_Template, 3, 1, "div", 22);
    i0.ɵɵpipe(7, "isItemSelected");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const item_r8 = ctx_r11.$implicit;
    const isFirstSectionItem_r13 = ctx_r11.first;
    const section_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("metric-scroll-id", i0.ɵɵpipeBind4(1, 5, ctx_r2.metricByCategoryListId, item_r8.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("category-top-scroll-id", isFirstSectionItem_r13 && !section_r5.section_label ? i0.ɵɵpipeBind2(3, 10, ctx_r2.metricByCategoryListId, ctx_r2.categorySelected.category_label) : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", item_r8.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showInfoPopover);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBindV(7, 13, i0.ɵɵpureFunction4(19, _c3, ctx_r2.selectedMetricsMap, item_r8.internal_name, ctx_r2.categorySelected.category_label, section_r5.section_label)));
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_div_1_Template, 3, 5, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtemplate(3, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", 16)(4, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_4_Template, 14, 16, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_ng_template_6_Template, 8, 24, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const isFirstSectionItem_r13 = ctx.first;
    const dropdownBlock_r16 = i0.ɵɵreference(5);
    const itemBlock_r17 = i0.ɵɵreference(7);
    const section_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", isFirstSectionItem_r13 && section_r5.section_label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (item_r8 == null ? null : item_r8.menu_label) && (item_r8 == null ? null : item_r8.periods))("ngIfThen", dropdownBlock_r16)("ngIfElse", itemBlock_r17);
} }
function SingleMetricByCategoryListComponent_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleMetricByCategoryListComponent_div_10_ng_container_1_ng_container_1_Template, 8, 4, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", section_r5.items);
} }
function SingleMetricByCategoryListComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, SingleMetricByCategoryListComponent_div_10_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.categorySelected.sections);
} }
/**
 * Single Metric By Category List
 *
 * Outputs:
 *   submitMetricHandler: An event emitter that emits a selected metric.
 *
 */
export class SingleMetricByCategoryListComponent extends MetricByCategoryListDirective {
    constructor(changeDetector, getCategoryScrollId, getCategoryTopScrollId, getMetricScrollId) {
        super(getCategoryScrollId, getCategoryTopScrollId, getMetricScrollId);
        this.changeDetector = changeDetector;
        this.getCategoryScrollId = getCategoryScrollId;
        this.getCategoryTopScrollId = getCategoryTopScrollId;
        this.getMetricScrollId = getMetricScrollId;
        this.submitMetricHandler = new EventEmitter();
    }
    // eslint-disable-next-line unused-imports/no-unused-vars-ts
    selectMetric(metric, ..._) {
        // Notify the metric modal of the selected metric
        this.submitMetricHandler.emit(metric);
    }
    // Reset maps
    // Add check mark for and scroll to preselected metric
    reset() {
        super.reset();
        if (this.selectedMetricName && this.selectedMetricName in this.flatMetricsMap) {
            const metricInfo = this.getMetricInfo(this.selectedMetricName);
            this.addSelectedMetricToMaps(metricInfo);
            this.scrollToMetric(metricInfo);
        }
        this.changeDetector.markForCheck();
    }
}
SingleMetricByCategoryListComponent.ɵfac = function SingleMetricByCategoryListComponent_Factory(t) { return new (t || SingleMetricByCategoryListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.GetCategoryScrollIdPipe), i0.ɵɵdirectiveInject(i2.GetCategoryTopScrollIdPipe), i0.ɵɵdirectiveInject(i3.GetMetricScrollIdPipe)); };
SingleMetricByCategoryListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleMetricByCategoryListComponent, selectors: [["ycn-single-metric-by-category-list"]], inputs: { selectedMetricName: "selectedMetricName" }, outputs: { submitMetricHandler: "submitMetricHandler" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 2, consts: [["metricInfoModal", ""], ["dropdownBlock", ""], ["itemBlock", ""], [1, "modal-section"], ["id", "metric-by-category-list-container", 1, "linked-lists"], [1, "linked-list", "user-select-none"], [1, "linked-list-header"], [1, "linked-list-body"], ["class", "linked-list-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "linked-list-body", 4, "ngIf"], [1, "linked-list-item", 3, "ngClass"], [1, "linked-list-item-header", 3, "click"], [3, "textContent"], [4, "ngFor", "ngForOf"], ["class", "linked-list-item-header", 4, "ngIf"], [1, "linked-list-item-body", "linked-list-sublist"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "linked-list-item-header"], [1, "linked-list-item", "linked-list-item-dropdown", 3, "ngClass"], [1, "btn", "dropdown-toggler"], [1, "text-gray-10", "linked-list-item-header-wrap"], ["class", "btn btn-xs btn-circle btn-transparent btn-i", 3, "click", 4, "ngIf"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-body"], [1, "linked-list-item-content"], [1, "linked-list-item-content-title"], ["class", "linked-list-item", 4, "ngFor", "ngForOf"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-i", 3, "click"], ["role", "img", "ycnIcon", "", 3, "name"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], [1, "linked-list-item"], [1, "text-gray-10"]], template: function SingleMetricByCategoryListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "div", 6);
        i0.ɵɵtext(4, "Category");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 7);
        i0.ɵɵtemplate(6, SingleMetricByCategoryListComponent_div_6_Template, 4, 8, "div", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
        i0.ɵɵtext(9, "Metric");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, SingleMetricByCategoryListComponent_div_10_Template, 2, 1, "div", 9);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(11, "ycn-metric-info-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.categories);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.categorySelected);
    } }, dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i5.IconDirective, i6.MetricInfoModalComponent, i7.GetCategoryScrollIdPipe, i8.GetCategoryTopScrollIdPipe, i9.GetMetricScrollIdPipe, i10.IsItemSelected, i11.IsSubmenuItemSelected], encapsulation: 2, changeDetection: 0 });
